import { HiShieldCheck } from "react-icons/hi";
import { MdCancel, MdAnalytics } from "react-icons/md";
const data = [
  {
    icon: <HiShieldCheck/>,
    heading: "Best interest rates on the market",
    detail:
      "Unlock the best interest rates on the market and secure your dream property with ease. Take advantage of competitive rates to make your real estate dreams a reality.",
  },
  {
    icon: <MdCancel />,
    heading: "Prevent unstable prices",
    detail:
      "Shield yourself from unpredictable price fluctuations in the real estate market. Safeguard your investments and ensure stability with our expert guidance and reliable market analysis.",
  },
  {
    icon: <MdAnalytics />,
    heading: "Best price on the market",
    detail:
      "Discover the best prices on the market for your real estate needs. Take advantage of our competitive rates and unlock exceptional value for your property investments.",
  },
];
export default data;